namespace Matrix.Scheduling {
    export interface CalendarEntryForm {
        CalendarCode: FormatLookupEditor;
        EntryDate: Serenity.DateEditor;
        Description: Serenity.StringEditor;
        Exclude: Serenity.BooleanEditor;
        RowId: Serenity.IntegerEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class CalendarEntryForm extends Serenity.PrefixedContext {
        static formKey = 'Scheduling.CalendarEntry';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CalendarEntryForm.init)  {
                CalendarEntryForm.init = true;

                var s = Serenity;
                var w0 = FormatLookupEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.IntegerEditor;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(CalendarEntryForm, [
                    'CalendarCode', w0,
                    'EntryDate', w1,
                    'Description', w2,
                    'Exclude', w3,
                    'RowId', w4,
                    'Version', w5,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6
                ]);
            }
        }
    }
}
